<div class="quick-commands" [ngClass]="{ 'quick-commands--busy': busy() }">
  @if (selectedResults().length > 0) {
    <div class="quick-commands__active-commands">
      @for (result of selectedResults(); track result.label) {
        <div class="quick-commands__active-command">
          <!-- Label -->
          @if ($last === false) {
            <button
              class="btn btn-link btn--portal-link"
              [innerHTML]="result.label"
              (click)="goToResult($index)"
            ></button>

            <i class="far fa-angle-right icon-angle"></i>
          } @else {
            <span [innerHTML]="result.label"></span>

            <!-- Disable command -->
            @if ($last) {
              <portal-icon-button
                class="ml-1"
                (onClick)="clearCommand()"
                iconClass="far fa-times"
              ></portal-icon-button>
            }
          }
        </div>
      }
    </div>
  }

  <header class="quick-commands__header">
    <div class="quick-commands__search">
      <!-- Magnifier icon -->
      <i class="far fa-search fa-fw quick-commands__search-icon"></i>

      <!-- Query input -->
      <input
        class="quick-commands__input"
        #input
        [(ngModel)]="query"
        [placeholder]="placeholder() ?? 'quickCommands.placeholder' | portalTranslate"
        (input)="onInput()"
        (keydown.alt.arrowLeft)="onAltLeft()"
        (keydown.arrowDown)="shiftFocus(1, $event)"
        (keydown.arrowUp)="shiftFocus(-1, $event)"
        (keydown.delete)="deleteActive()"
        (keydown.enter)="onEnter(active())"
        (keydown.pageDown)="shiftFocus(10, $event)"
        (keydown.pageUp)="shiftFocus(-10, $event)"
        autocomplete="off"
        type="text"
      />
    </div>
  </header>

  <!-- Results -->
  <div class="quick-commands__results">
    <portal-loading-indicator [fixed]="true" [show]="busy()"></portal-loading-indicator>

    @if (busy() === false) {
      <portal-errors class="quick-commands__error" [dismissible]="false" [errors]="error()" />

      <ul class="quick-commands__result-list">
        @if (entries().length > 0) {
          @if (infoMessage() != null) {
            <li class="quick-commands__result quick-commands__feedback quick-commands__feedback--info">
              <span [innerHTML]="infoMessage() | portalTranslate"></span>
            </li>
          } @else if (warningMessage() != null) {
            <li class="quick-commands__result quick-commands__feedback quick-commands__feedback--warning">
              <span [innerHTML]="warningMessage() | portalTranslate"></span>
            </li>
          }
        }

        <!-- Sections -->
        @for (section of sections(); track section.label) {
          <!-- TODO Remove this ng-template after we upgraded to angular > 18.1.0 (bug: https://github.com/angular/angular/issues/57160) -->
          <ng-template></ng-template>

          @let hasSections = sections().length > 1;
          @let hasResults = selectedResults().length > 0;
          @let showSectionHeader = hasSections || (alwaysShowSections() && hasResults);
          @let headerIsNotBlank = section.label | translate | notBlank;

          <!-- Section header -->
          @if (showSectionHeader && headerIsNotBlank) {
            <li class="quick-commands__result quick-commands__result--section" [ngClass]="section.className">
              {{ section.label | translate: { name: currentGroup() } }}
            </li>
          }

          <!-- Groups -->
          @for (group of section.groups; track group.label) {
            <!-- Group header -->
            @if (group.label && group.label !== currentGroup()) {
              <li class="quick-commands__result quick-commands__result--group">
                {{ group.label | translate }}
              </li>
            }

            <!-- Results -->
            @for (result of group.entries; track result.index) {
              <li
                class="quick-commands__result"
                [id]="'result-' + result.index"
                [ngClass]="{
                  active: active() === result.index,
                  historic: result.section === 'history',
                  readonly: readonly(),
                  selected: result.active,
                }"
                (click)="onClick(result.index, result)"
                (mousedown)="setFocus(result.index)"
                (mouseover)="setFocus(result.index)"
              >
                <portal-quick-command-name
                  [command]="activeCommand()"
                  [group]="section.name === HistorySection.name ? result.group : null"
                  [highlight]="highlightResults()"
                  [query]="query()"
                  [result]="result"
                ></portal-quick-command-name>

                @if (lastCommand() == null) {
                  <portal-reveal-details class="quick-commands__details">
                    {{
                      'quickCommands.usageCount'
                        | translate: { count: commandUsage()[result.command?.name]?.count ?? 0 }
                    }}
                  </portal-reveal-details>
                }
              </li>
            }
          }
        }

        @if (entries().length === 0 && error() == null) {
          @if (infoMessage() != null) {
            <li class="quick-commands__result quick-commands__feedback quick-commands__feedback--info">
              <span [innerHTML]="infoMessage() | portalTranslate"></span>
            </li>
          }

          @if (warningMessage() != null) {
            <li
              class="quick-commands__result quick-commands__feedback quick-commands__feedback--warning alert alert-warning"
            >
              <span [innerHTML]="warningMessage() | portalTranslate"></span>
            </li>
          }

          @if (errorMessage() == null) {
            <li class="quick-commands__result quick-commands__feedback">
              <span [innerHTML]="emptyMessage() ?? 'quickCommands.noResults' | portalTranslate"></span>
            </li>
          } @else {
            <li class="quick-commands__result quick-commands__feedback quick-commands__feedback--invalid">
              <span [innerHTML]="errorMessage() | portalTranslate"></span>
            </li>
          }
        }
      </ul>
    }
  </div>

  @if (statusbar().hide !== false) {
    <div class="quick-commands__status-bar">
      <div [innerHTML]="statusbarTranslation() | portalTranslate"></div>
      @if (statusbar().hideDefaultHint !== true) {
        <div [innerHTML]="'quickCommands.statusbar.defaultHint.html' | translate"></div>
      }
    </div>
  }
</div>
